/**
 * API configuration
 * Defines base URL and endpoint paths for backend API
 */

export const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export const API_ENDPOINTS = {
  // Jobs endpoints
  UPLOAD_CSV: '/upload',
  PROCESS_CSV: '/process-csv',
  JOBS: '/jobs',
  JOB_DETAIL: (jobId) => `/jobs/${jobId}`,

  // Estimates endpoints
  ESTIMATES: '/estimates',
  ESTIMATE_DETAIL: (estimateId) => `/estimates/${estimateId}`,
  ESTIMATE_UPLOAD: '/estimates/upload',
  SEARCH_SIMILAR_ESTIMATES: '/estimates/search/similar',
  SEARCH_SIMILAR_LINE_ITEMS: '/estimates/search/line-items',

  // Quotes endpoints
  QUOTES: '/quotes',
  QUOTE_DETAIL: (quoteId) => `/quotes/${quoteId}`,
  APPROVE_QUOTE: (quoteId) => `/quotes/${quoteId}/approve`,
  REJECT_QUOTE: (quoteId) => `/quotes/${quoteId}/reject`,

  // Admin endpoints
  ADMIN_TENANTS: '/admin/tenants',
  ADMIN_TENANT_DETAIL: (tenantId) => `/admin/tenants/${tenantId}`,
  ADMIN_TENANT_UPLOAD: (tenantId) => `/admin/tenants/${tenantId}/upload`,

  // Public endpoints (no auth required)
  PUBLIC_TENANT: '/public/tenant',

  // Settings endpoints
  PRICING_RULES: '/settings/pricing-rules',
  ADMIN_PRICING_RULES: '/admin/pricing-rules',
  LINE_ITEM_MAPPINGS: '/settings/line-item-mappings',
  LINE_ITEM_MAPPING_DETAIL: (normalizedDescription) =>
    `/settings/line-item-mappings/${encodeURIComponent(normalizedDescription)}`,

  // Feedback endpoint
  FEEDBACK: '/feedback',
};

// Validate API URL is configured
if (!API_BASE_URL && process.env.NODE_ENV === 'development') {
  console.warn(
    'REACT_APP_API_URL is not configured. API calls will fail. ' +
    'Set this value in .env.local from pulumi stack output api_gateway_url.'
  );
}
